export default __webpack_public_path__ + "static/media/arrow.90a4b9d3.svg";